import {TextViewerFontFamilyType} from './type/TextViewerFontFamilyType.enum';

export const DEFAULT_FONT_SIZE = 20;
export const DEFAULT_LINE_HEIGHT = 1.6;

// 유효자리수(1/10)의 역수. 소수점 첫째자리까지 유효숫자로 둡니다.
export const SIGNIFICANT_DIGIT_RECIPROCAL = 10;

export const DEFAULT_CONTAINER_CLASSNAME = 'DC1CN';
export const DEFAULT_CONTENT_CLASSNAME = 'DC2CN';

export const NORMALIZED_STYLE = `
:host { all: initial; }
`;

// 아래 주소를 참고해서 컨텐츠 기본 스타일을 만들었습니다.
// https://github.com/readium/readium-css/blob/master/css/dist/ReadiumCSS-before.css
// https://github.kakaocorp.com/kakaopage/ios/blob/develop/KaKaoPage/Classes/Viewer/BookViewer/Epub/Readium/ReadiumCSS-before.css
export const DEFAULT_STYLE = `
* {
  orphans: 1;
  widows: 1;
}

html {
  line-height: 1.5;
  text-rendering: optimizeLegibility;
}

h1, h2, h3 {
  line-height: normal;
}

body {
  -webkit-hyphenate-character: "\\002D";
  hyphenate-character: "\\002D";
  -webkit-hyphenate-limit-lines: 3;
  hyphenate-limit-lines: 3;
}

h1, h2, h3, h4, h5, h6, dt,
figcaption, pre, caption, address,
center, code, var {
  -webkit-hyphens: none;
  -epub-hyphens: none;
  hyphens: none;
}

hr {
  color: inherit;
  border-color: currentColor;
}

table, th, td {
  border-color: currentColor;
}

figure, blockquote {
  margin: 1em 5%;
}

ul, ol {
  padding-left: 5%;
}

dd {
  margin-left: 5%;
}

pre {
  white-space: pre-wrap;
  -webkit-tab-size: 2;
  tab-size: 2;
}

abbr[title], acronym[title] {
  text-decoration: dotted underline;
}

nobr wbr {
  white-space: normal;
}

ruby > rt, ruby > rp {
  -webkit-user-select: none;
  user-select: none;
}

a, h1, h2, h3, h4, h5, h6 {
  word-wrap: break-word;
}

img, svg, audio, video {
  object-fit: contain;
}

img.tv-zoom:hover, svg.tv-zoom:hover {
  cursor: zoom-in;
}
`;

export const TEXT_VIEWER_FONT_FAMILY_FILE_NAME: {
  [key in TextViewerFontFamilyType]: string;
} = {
  [TextViewerFontFamilyType.Gothic]: 'KoPubDotum-Light.woff',
  [TextViewerFontFamilyType.Batang]: 'KoPubBatang-Light.woff',
  [TextViewerFontFamilyType.Myeongjo]: 'NanumMyeongjo.woff',
};

export enum PageCounterStatus {
  NoCount,
  OnlyCurrentPageCount,
  AllCount,
}

export const viewerHistory: number[] = [];
export const TEXT_VIEWER_SCROLL_THRESHOLD = 20;
